<template>
  <div class="publiceTit">
    <div class="title">
      <p class="titleBg">{{titleObj.eng}}</p>
      <p class="titleCon">{{titleObj.name}}</p>
      <span class="line"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: ['titleObj'],
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/publiceTit/index.vue